var _path, _mask, _rect, _mask2, _rect2, _path2, _mask3, _rect3, _mask4, _rect4, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVilla = function SvgVilla(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 50 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.894,
    d: "M39.984 14.596V37.2M7.021 14.404h36.5"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "villa_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 4,
    x: 12.094,
    y: 19.109,
    rx: 0.383
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 4,
    x: 12.094,
    y: 19.109,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#villa_svg__a)",
    rx: 0.383
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "villa_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 4,
    x: 28.594,
    y: 19.109,
    rx: 0.383
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 4,
    x: 28.594,
    y: 19.109,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#villa_svg__b)",
    rx: 0.383
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.894,
    d: "M22.494 14.713v22M24.494 14.713v22"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "villa_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 4,
    x: 12.094,
    y: 26.844,
    rx: 0.383
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 4,
    x: 12.094,
    y: 26.844,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#villa_svg__c)",
    rx: 0.383
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "villa_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 4,
    x: 28.594,
    y: 26.844,
    rx: 0.383
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 4,
    x: 28.594,
    y: 26.844,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#villa_svg__d)",
    rx: 0.383
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 0.894,
    d: "m39.984 14.596-2.962-4.252"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 0.894,
    d: "M9.53 10 6.7 14.406V37.2h37.265V14.406L40.943 10z"
  })));
};
export default SvgVilla;